/** The map an enemy belongs to, or null for one added before enemies had a map. */
export const enemyMapId = (enemy) => (typeof enemy?.mapId === 'string' && enemy.mapId.trim() ? enemy.mapId.trim() : null);

/** Whether the DM's lists show this enemy on a map: its own map, or every map when it has none. */
export const isEnemyOnMap = (enemy, mapId) => !mapId || !enemyMapId(enemy) || enemyMapId(enemy) === mapId;

/** The Enemies panel: this map's creatures first, then, with Show all maps on, the rest. */
export const enemiesForPanel = (enemies, mapId, showAllMaps) => {
  const list = Array.isArray(enemies) ? enemies : [];
  const here = list.filter((enemy) => isEnemyOnMap(enemy, mapId));
  return showAllMaps ? [...here, ...list.filter((enemy) => !isEnemyOnMap(enemy, mapId))] : here;
};

/** The tag and Move button a card shows: null for an enemy already tied to this map. */
export const enemyMapTag = (enemy, mapId, maps = []) => {
  const own = enemyMapId(enemy);
  if (!mapId || own === mapId) return null;
  const map = maps.find((entry) => entry?.mapId === own);
  return { label: own ? map?.title || map?.name || 'Another map' : 'All maps', elsewhere: Boolean(own) };
};
